import { createContext, useContext, useEffect, useState } from "react"

import { useCraftProp, usePureCraftProp } from "../../utils"
import { searchItems } from "../components/tailwindSandbox"

import { ANIMATION_CATEGORIES } from "./animationsPredefined"

const AnimationContext = createContext()

export const AnimationProvider = ({ children }) => {
  const [animationState, setAnimationState] = useState()
  const [animation, setAnimation] = useState({ rightClick: {}, search: '', items: ANIMATION_CATEGORIES })

  const { rawValue, value: raw, setValue: setRaw } = useCraftProp('animation')
  const { value: name } = useCraftProp('animation.name')
  const { setValue: setValuePure } = usePureCraftProp('properties.animation')

  const handleCloseContextMenu = () => {
    setAnimation({ ...animation, rightClick: {} })
  }

  useEffect(() => {
    if (rawValue?.name) {
      setValuePure(convertOldAnimation(rawValue))
    }
  }, [setRaw, raw, name, rawValue, setValuePure])

  useEffect(() => {
    const query = animation.search
    const items = searchItems({ query, defaultItems: ANIMATION_CATEGORIES, keysToSearch: ['name', 'category'] })
    if (items.length !== animation.items.length) {
      setAnimation({ ...animation, items })
    }
  }, [animation.search, animation])

  return (
    <AnimationContext.Provider value={{ animation, setAnimation, onCloseContextMenu: handleCloseContextMenu, animationState, setAnimationState }}>
      {!raw && name ? null : children}
    </AnimationContext.Provider>
  )
}

function extractValues(rawObject, device, utility = null) {
  const entries = Object.entries(rawObject).map(([key, value]) => {
    if (value === null || typeof value !== 'object') {
      return [key, device === 'desktop' && !utility ? value : null]
    }
    if (Object.prototype.hasOwnProperty.call(value, device)) {
      const deviceValue = value[device]
      if (deviceValue && typeof deviceValue === 'object') {
        return [key, utility ? deviceValue[utility] ?? null : deviceValue.default ?? null]
      }
      return [key, utility ? null : deviceValue]
    }
    if (device === 'desktop') {
      return [key, utility ? value[utility] ?? null : value.default ?? null]
    }
    return [key, null]
  })
  const filtered = entries.filter(([, val]) => val !== null && val !== undefined)
  return filtered.length ? Object.fromEntries(filtered) : null
}

function convertOldAnimation(rawValue) {
  if (!rawValue) {
    return
  }

  const response = {}

  const desktop = extractValues(rawValue, 'desktop') || {}
  const desktopUtility = extractValues(rawValue, 'desktop', 'hover') || {}

  for (const device of DEVICES) {
    for (const utility of UTILITIES) {
      const deviceValue = extractValues(rawValue, device)
      const deviceUtilityValue = extractValues(rawValue, device, utility)

      if (deviceValue || deviceUtilityValue) {
        const defaultValue = [{ ...desktop, ...deviceValue }]
        const utilityValue = [{ ...desktopUtility, ...deviceUtilityValue }]
        response[device] = deviceUtilityValue ? { default: defaultValue, [utility]: utilityValue } : defaultValue
      }
    }
  }

  if (response.desktop && !response.mobile) {
    return response.desktop
  }

  return response
}

const DEVICES = ['desktop', 'mobile']
const UTILITIES = ['hover']

export const useAnimation = () => useContext(AnimationContext)
